import React, { useState, useCallback, FunctionComponent } from 'react';
import Translate from 'ui/atoms/translate';
import WithAuthenticatedPage from 'core/auth/components/with-authenticated-page';
import { AppType } from 'core/auth/types';
import WideContent from 'core/layout/content/wide-content';
import Button from 'ui/atoms/button';
import AddSettlementModal from './add-settlement-modal';
import SettlementsTable from './settlements-table';
import { useCurrentUserSelector } from 'src/core/auth/hooks';
import { hasDistributionViewDataPermission } from '../../helpers/distributionPlatformPermissions';
import { hasManageTriggerSolutionPermission, hasViewPermission } from '../../helpers/tokenPermissions';
import Spacer from 'src/ui/atoms/spacer';

const TriggerSolutionSettlementsPage: FunctionComponent = () => {
  const [isAddSettlementModalOpen, setAddSettlementModalOpen] = useState(false);
  const [forceDataLoad, setForceDataLoad] = useState(false);

  const { currentUser } = useCurrentUserSelector();

  const hasPermission =
    hasDistributionViewDataPermission(currentUser?.associatedDistributionPlatforms || []) ||
    (hasViewPermission(currentUser) && hasManageTriggerSolutionPermission(currentUser));

  const refreshTableData = useCallback(() => {
    setForceDataLoad(true);
    setAddSettlementModalOpen(false);
  }, []);

  return (
    <WideContent title={<Translate name="dashboardIssuerTriggerSolution.title" />}>
      {hasPermission && (
        <>
          <Button
            variant="primary"
            icon="plus"
            size="small"
            iconSize="small"
            iconColor="inherit"
            onClick={() => setAddSettlementModalOpen(true)}
          >
            <Translate name="dashboardIssuerTriggerSolution.addSettlement" />
          </Button>
          <Spacer y={4} />
        </>
      )}

      <SettlementsTable
        defaultLimit={10}
        forceDataLoad={forceDataLoad}
        setForceDataLoad={setForceDataLoad}
        hasPermission={hasPermission}
      />

      {isAddSettlementModalOpen && (
        <AddSettlementModal onClose={() => setAddSettlementModalOpen(false)} onAddNewSettlement={refreshTableData} />
      )}
    </WideContent>
  );
};

export default WithAuthenticatedPage(TriggerSolutionSettlementsPage, AppType.ISSUER);
